import React from 'react';
import MobileMainLayout from '../../layout/MobileMainLayout';

const Tasla = () => {
  return (
    <MobileMainLayout title="Tasla" link="javascript:;">
      Working on it...
      {/* <SkincareBanner />

      <div className="mb-3">
        <ShopByCategorySkincare title="Skincare Products" />
      </div> */}
    </MobileMainLayout>
  );
};

export default Tasla;
